import styled from 'styled-components'

import { FLAG_COLOURS } from 'constants/colors'

export const StyledContainer = styled.div`
  margin-top: 5px;
  font-size: 12px;
  color: ${FLAG_COLOURS.ERROR};
`
